import React, { useState } from "react";
import { ASSETS, TOAST_TYPE } from "../../utils/config";
import "./styles.css";
import BusniessBoxGrid from "./Children/BusniessBoxGrid";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  IconButton,
  Switch,
  Typography,
} from "@mui/material";
import CreateEditBusinessBox from "./CreateEditBusinessBox";
import DeleteIcon from "@mui/icons-material/Delete";
import BusinessBoxPreview from "./BusinessBoxPreview";
import DeleteBusinessBoxModal from "./Children/DeleteBusinessBoxModal";
import { useDeleteBusinessBox } from "../../services/mutations";
import ToastMessage from "../../sharedcomponents/Toast";
import { isEmpty } from "lodash";

const AllBusinessBoxes = ({
  showHeader,
  businessBoxes,
  businessBoxApiLoading,
  refetch,
  setOpenPreview,
  selectedBoxCardData,
  setSelectedBoxCardData,
  handleBusinessBoxSelect = () => {},
  refetchPrimaryBusinessBox = () => {},
  handleApplyBboxEverywhere = () => {},
  isEditable = true,
}) => {
  const [openBBModal, setOpenBBModal] = useState(false);
  const [openDeleteBBModal, setOpenDeleteBBModal] = useState(false);
  const [checked, setChecked] = useState(selectedBoxCardData?.is_base ?? false);

  const handleApplyBboxCheckbox = (event) => {
    setChecked(event.target.checked);
    handleApplyBboxEverywhere(event);
  };

  const deleteBusinessBox = useDeleteBusinessBox();

  const [deleteBBLoading, setDeleteBBLoading] = useState(false);

  const handleOpenDeleteBBModal = () => setOpenDeleteBBModal(true);
  const handleCloseDeleteBBModal = () => {
    setOpenDeleteBBModal(false);
  };

  const handleOpenBBModal = () => setOpenBBModal(true);
  const handleCloseBBModal = (e, reason) => {
    if (reason !== "backdropClick") {
      setOpenBBModal(false);
    }
  };

  const handlePreviousBoxSelect = (businessBoxData) => {
    setChecked(false);
    setSelectedBoxCardData(businessBoxData);
  };

  const handleCreateNewBB = () => {
    setSelectedBoxCardData(null);
    setChecked(false);
    handleOpenBBModal();
  };

  const handleBBSelect = () => {
    if (selectedBoxCardData) {
      setOpenPreview(true);
      handleBusinessBoxSelect(selectedBoxCardData, false, true);
    }
  };

  const handleBBEdit = () => {
    if (selectedBoxCardData) {
      handleOpenBBModal();
    }
  };

  const handleBBDelete = () => {
    if (selectedBoxCardData) {
      handleOpenDeleteBBModal();
      setChecked(false);
    }
  };

  const refetchData = async () => {
    // setIsLoading(true);
    await refetch();
    // setIsLoading(false);
  };

  const handleDeleteBusinessBox = () => {
    setDeleteBBLoading(true);
    deleteBusinessBox.mutate(
      { ...selectedBoxCardData },
      {
        onSuccess: (response) => {
          setDeleteBBLoading(false);
          handleCloseDeleteBBModal();
          setSelectedBoxCardData(null);
          refetchData();
          refetchPrimaryBusinessBox();
        },
        onError: (err) => {
          console.log("Delete Error:::", err);
          setDeleteBBLoading(false);
        },
      }
    );
  };

  return (
    <>
      <CreateEditBusinessBox
        showHeader={false}
        initialValues={selectedBoxCardData || null}
        refetch={refetchData}
        open={openBBModal}
        onClose={handleCloseBBModal}
        setSelectedBoxCardData={setSelectedBoxCardData}
      />

      {deleteBusinessBox.isError && (
        <ToastMessage
          message={"Something went wrong, Try again !"}
          type={TOAST_TYPE.ERROR}
        />
      )}
      {deleteBusinessBox.isSuccess && (
        <ToastMessage
          message={`Business Box has been deleted!`}
          type={TOAST_TYPE.SUCCESS}
        />
      )}

      <DeleteBusinessBoxModal
        open={openDeleteBBModal}
        onClose={handleCloseDeleteBBModal}
        message={
          "Are you sure you want to remove the box from your library? It will not be restored later!"
        }
        primaryButtonText={"Yes, Delete"}
        secondaryButtonText={"Cancel"}
        handleSubmit={handleDeleteBusinessBox}
        isLoading={deleteBBLoading}
      />
      <>
        {businessBoxApiLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          >
            <CircularProgress size={48} style={{ color: "#123051" }} />
          </div>
        ) : (
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              backgroundColor: "white",
              padding: "5px",
              borderRadius: "12px",
              // paddingTop: "15px",
              // paddinBottom: "20px",
            }}
          >
            {showHeader ? (
              <Box
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    margin: "5px",
                    marginLeft: "1px",
                  }}
                >
                  <img
                    src={ASSETS.businessbox}
                    alt="titleImg"
                    style={{
                      width: "27px",
                      height: "21px",
                      marginRight: "5px",
                    }}
                  />
                  <Typography
                    variant="h6"
                    style={{
                      fontSize: "14px",
                      fontFamily: "DM Sans",
                      lineHeight: "17px",
                      fontWeight: "500",
                    }}
                  >
                    Business Box
                  </Typography>
                </Box>
                {isEditable ? (
                  <img
                    src={ASSETS.addLink}
                    alt="adlink"
                    style={{ width: "15px", height: "15px", cursor: "pointer" }}
                  />
                ) : null}
              </Box>
            ) : null}

            {showHeader ? (
              <Typography
                variant="h6"
                style={{
                  fontSize: "10px",
                  fontWeight: "700",
                  fontFamily: "DM Sans",
                  color: "#565556",
                  margin: "8px",
                }}
              >
                Business Box Library ({businessBoxes?.length})
              </Typography>
            ) : (
              <Box
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h6"
                  style={{
                    fontSize: "10px",
                    fontWeight: "700",
                    fontFamily: "DM Sans",
                    color: "#565556",
                    margin: "8px",
                  }}
                >
                  Business Box Library ({businessBoxes?.length})
                </Typography>

                {isEditable ? (
                  <Box
                    sx={{
                      display: "flex !important",
                      justifyContent: "space-between !important",
                    }}
                  >
                    <IconButton
                      color="primary"
                      sx={{
                        width: "24px !important ",
                        height: "24px !important",
                      }}
                    >
                      <img
                        src={ASSETS.edit}
                        onClick={handleBBEdit}
                        alt={"Favourite"}
                        width="16px"
                        height="16px"
                      />
                    </IconButton>

                    <IconButton
                      color="primary"
                      sx={{
                        width: "24px !important ",
                        height: "24px !important",
                      }}
                    >
                      <img
                        src={ASSETS.delete_icon}
                        alt="Delete"
                        width="16px"
                        height="16px"
                        className="deleteIcon"
                        onClick={handleBBDelete}
                      />
                    </IconButton>
                  </Box>
                ) : null}
              </Box>
            )}

            <Box
              style={{
                marginBottom: "10px",
                width: "100%",
                borderRadius: "14px",
                overflow: "hidden",
                // backgroundColor: "#F6F7F9",
              }}
            >
              <BusniessBoxGrid
                allBusinessBoxes={businessBoxes}
                handleSelect={handlePreviousBoxSelect}
                selectedBoxCardData={selectedBoxCardData}
                handleCreateNewBB={handleCreateNewBB}
                isEditable={isEditable}
              />
            </Box>

            <Box
              sx={{
                borderBottom: "1px solid #BBBBBB",
              }}
            ></Box>

            <Box
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "10px",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <Checkbox
                checked={checked}
                onChange={handleApplyBboxCheckbox}
                sx={{ padding: 0 }}
                disabled={isEmpty(selectedBoxCardData)}
              />
              <Typography
                variant="h6"
                style={{
                  fontSize: "10px",
                  fontFamily: "DM Sans",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                }}
              >
                Apply this Business Box to all Wheels
              </Typography>
            </Box>

            {isEditable ? (
              <Box
                sx={{
                  marginTop: "15px !important",
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#123051 !important",
                    fontSize: "12px !important",
                    fontFamily: "DM Sans !important",
                    textAlign: "center !important",
                    color: "white !important",
                    borderRadius: "5px !important",
                    padding: "8px 30px !important",
                    height: "25px !important",
                    textTransform: "capitalize",
                    "&.Mui-disabled": {
                      backgroundColor: "#0000001f !important",
                    },
                  }}
                  fullWidth
                  onClick={handleBBSelect}
                  disabled={isEmpty(selectedBoxCardData)}
                >
                  Select
                </Button>
              </Box>
            ) : null}
          </Box>
        )}
      </>
    </>
  );
};

export default AllBusinessBoxes;
